import { render, staticRenderFns } from "./CopyContent.vue?vue&type=template&id=e72efde4&scoped=true&"
import script from "./CopyContent.vue?vue&type=script&lang=js&"
export * from "./CopyContent.vue?vue&type=script&lang=js&"
import style0 from "./CopyContent.vue?vue&type=style&index=0&id=e72efde4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e72efde4",
  null
  
)

export default component.exports